import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  gap: 1rem;
`

const MainContainer = styled(Container)`
  flex-direction: column;
  padding: 3rem 0 6rem;
  background-color: ${({ theme }) => theme.colors.boxBackground};
`

export const MobileMainContainer = styled(MainContainer)`
  @media (min-width: 768px) {
    display: none;
  }
`

export const DesktopMainContainer = styled(MainContainer)`
  max-width: 1200px;
  margin: 3rem auto;

  @media (max-width: 767px) {
    display: none;
  }
`

export const MainTitle = styled(Container)`
  flex-direction: column;
  gap: 1.29rem;
`

export const MainDescription = styled(Container)`
  flex-direction: column;
`

export const ButtonContainer = styled(Container)`
  flex-direction: column;
  gap: 1.5rem;
  padding: 0 0 2rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    padding: 1.5rem 1.5rem 1rem;
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    flex-wrap: wrap;
  }
`

export const StarContainer = styled(Container)`
  flex-wrap: wrap;
  width: 15rem;
  padding: 1rem 0 0;

  > .skeleton-reviews-count {
    @media (max-width: 767px) {
      margin-top: -2rem;
      margin-left: auto;
    }
  }

  @media (min-width: 768px) {
    display: flex;
    width: 20rem;
    padding: 1rem 0;
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    width: 100%;
  }
`

export const StarSkeleton = styled(Skeleton)`
  width: 2.3rem;
  height: 3.3rem;

  @media (min-width: 768px) {
    padding-top: 0.5rem;
  }
`

export const Star = styled.div`
  display: inline-block;
  clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );
  width: 1.8rem;
  height: 1.8rem;

  @media (min-width: 768px) {
    width: 2.3rem;
    height: 2.3rem;
  }
`

export const ReviewsContainer = styled(Container)`
  flex-direction: column;
  padding: 3rem 0 0;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 9.6rem;
    padding: 2.5rem 0 0;
  }
`

export const TabsContainer = styled(Container)`
  gap: 3.5rem;
  padding: 1.5rem 0 0;
`

export const SortContainer = styled(Container)`
  justify-content: flex-end;

  @media (min-width: 768px) {
    padding: 2.5rem 0 0;
  }
`

export const Review = styled(Container)`
  flex-direction: column;
  padding: 3rem 0 0;
`

export const Details = styled(Container)`
  @media (min-width: 768px) {
    flex: none;
    flex-direction: column;
    gap: 0.5rem;
    width: 15.3rem;
  }
`

export const DetailsTitle = styled(Container)`
  justify-content: space-between;
  align-items: center;
`

export const VerifiedUser = styled(Container)`
  width: auto;
`

export const ReviewText = styled(Container)`
  flex-direction: column;
  padding-top: 0.5rem;

  @media (min-width: 768px) {
    padding: 0;
  }
`
